import React from 'react';
import Box from '@mui/material/Box';
import { Typography, TypographyProps } from '@mui/material';
import styled from 'styled-components';
import { SURVEY_STATUS_COLORS, PALETTE } from '~/assets/styles/base';
import { SURVEY_STATUSES, SurveyStatus } from '~/common/constants';

type StyledBoxProps = {
  $status: SurveyStatus;
};

const StyledBox = styled(Box)<StyledBoxProps>`
  min-width: 80px;
  width: fit-content;
  min-height: 22px;
  color: ${(props) =>
    props.$status === SURVEY_STATUSES.CANCELED ? PALETTE.cancel.sub : PALETTE.white};
  align-items: center;
  display: flex;
  justify-content: center;
  background: ${(props) => SURVEY_STATUS_COLORS[props.$status]};
`;

type Props = {
  label: string;
  variant?: TypographyProps['variant'];
  status: SurveyStatus;
};

const StatusBox: React.FC<Props> = ({ label, variant = 'body4', status }): JSX.Element => (
  <StyledBox $status={status} data-testid="uiElements-StatusBox">
    <Typography variant={variant} data-testid="uiElements-StatusBoxText">
      {label}
    </Typography>
  </StyledBox>
);

export default StatusBox;
